import {remCalc} from '../../_utils'

// Stories

export default {
    baseStyle: ({
        autoplayDelay,
        maskgroup,
    }: {
        autoplayDelay: number
        maskgroup: {maskheaderactive?: boolean; opacity: string}
    }) => {
        // ignore opacity color, it's always black
        const maskGradient = maskgroup?.maskheaderactive ? 'background.base.overlay' : 'transparent'

        return {
            container: {
                maxW: remCalc(1920),
                position: 'relative',
                my: {base: remCalc(16), md: remCalc(40)},
                mx: 'auto',
                bgColor: 'background.base.default',
            },
            slidercontainer: {
                w: '100%',
                maxW: {
                    base: remCalc(343),
                    sm: remCalc(720),
                    md: remCalc(976),
                    lg: remCalc(1400),
                },
                m: '0 auto',
                bgColor: 'background.base.default',

                // Swiper component styling
                '.stories-pagination-bullet': {
                    borderRadius: remCalc(1),
                    h: remCalc(1.031),
                    background: 'background.neutral.white',
                    opacity: 1,
                    flexGrow: 1,
                    cursor: 'pointer',
                },
                '.stories-pagination-bullet span': {
                    display: 'block',
                    borderRadius: remCalc(1),
                    h: remCalc(1.031),
                    w: 0,
                    background: 'foreground.neutral.inverse',
                },
                '.stories-pagination-bullet.full span': {
                    w: '100%',
                },
                '.stories-pagination-bullet.current span': {
                    transition: `width ${autoplayDelay}s linear`,
                    w: '100%',
                },
                '.swiper-slide .current .slideimage': {
                    transition: `transform ${autoplayDelay}s linear`,
                    transform: 'scale(1.1)',
                },
                '.swiper-button-disabled': {
                    display: 'none',
                },
            },
            mediaContainer: {
                position: 'relative',
                w: '100%',
                h: '100%',
            },
            screenImg: {
                w: '100%',
                h: '100%',
                objectFit: 'cover',
            },
            screenText: {
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: '50%',
                flexDirection: 'column',
                transform: 'translateX(-50%)',
                justifyContent: 'center',
                alignItems: 'center',
                w: '100%',
                background: maskGradient,
            },
            heading: {
                mb: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
                w: '80%',
                color: 'foreground.neutral.inverse',
                textAlign: 'center',
                textTransform: 'none',
                textStyle: 'display-small',
                fontWeight: 'medium',
                fontFamily: 'heading',
            },
            startctacontainer: {
                textAlign: 'center',
            },
            startcta: {
                minW: {base: remCalc(214), lg: remCalc(230), md: remCalc(310)},
            },
            closeButton: {
                zIndex: 3,
                color: 'foreground.neutral.inverse',
                position: 'absolute',
                top: {base: remCalc(12), sm: remCalc(14), md: remCalc(12)},
                right: {base: remCalc(12), sm: remCalc(14), md: remCalc(12)},
                w: {
                    base: 'iconsSize.medium',
                    lg: 'iconsSize.large',
                    xl: 'iconsSize.xlarge',
                },
                h: {
                    base: 'iconsSize.medium',
                    lg: 'iconsSize.large',
                    xl: 'iconsSize.xlarge',
                },
                fontSize: {base: remCalc(15), md: remCalc(16), lg: remCalc(20), xl: remCalc(24)},
            },
            chevronIcon: {
                w: remCalc(36),
                h: remCalc(36),
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                borderRadius: 'full',
                cursor: 'pointer',
                zIndex: 10,
                color: 'background.neutral.grey',
                bg: 'background.base.overlay',
                boxShadow: 'borderShadow',
                backdropFilter: 'blur(5px)',
                border: 'small',
                borderColor: 'border.neutral.highlight',
                borderStyle: 'solid',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            slide: {
                flexDirection: 'column',
                color: 'foreground.neutral.inverse',
                w: '100%',
                maxW: '100%',
                h: '100%',
                maxH: '100%',
                overflow: 'hidden',
            },
            slidemedia: {
                w: '100%',
                h: '100%',
                objectFit: 'cover',
                zIndex: 1,
            },
            slidetextblock: {
                position: 'absolute',
                top: 0,
                left: '50%',
                flexDirection: 'column',
                transform: 'translateX(-50%)',
                w: '80%',
                h: {base: `calc(100% - ${remCalc(34)})`, sm: `calc(100% - ${remCalc(50)})`},
                alignItems: 'flex-start',
                justifyContent: 'flex-end',
                zIndex: 3,
                gap: {base: remCalc(16), sm: remCalc(24)},
            },
            slidetitle: {
                w: '100%',
                textAlign: 'left',
            },
            slidetitletext: {
                textStyle: 'head-xlarge',
                fontWeight: 'medium',
                color: 'foreground.neutral.inverse',
            },
            slidebodycopy: {
                w: '100%',
                textAlign: 'left',
            },
            slidebodycopyhtml: {
                textStyle: 'body-large',
                fontWeight: 'normal',
                color: 'foreground.neutral.inverse',
                sx: {
                    p: {color: 'foreground.neutral.inverse'},
                    strong: {color: 'foreground.neutral.inverse'},
                    em: {color: 'foreground.neutral.inverse'},
                    u: {color: 'foreground.neutral.inverse'},
                    a: {
                        color: 'foreground.accent.inverse',
                        textDecoration: 'underline',
                    },
                },
            },
            slidemask: {
                position: 'absolute',
                w: '100%',
                h: '100%',
                background: maskGradient,
                zIndex: 2,
            },
            pagination: {
                zIndex: 10,
                position: 'absolute',
                bottom: {base: `${remCalc(16)} !important`, md: `${remCalc(24)} !important`},
                left: '50% !important',
                flexDirection: 'row',
                transform: 'translateX(-50%)',
                w: '80% !important',
                justifyContent: 'space-between',
                gap: remCalc(24),
            },
            endctacontainer: {
                textAlign: 'center',
            },
            endcta: {
                minW: {base: remCalc(214), lg: remCalc(230), md: remCalc(310)},
            },
        }
    },
}
